export default __webpack_public_path__ + "img/1a8d2b43a8c4da62b94c32ceaad800a5.svg";